import { deckImages } from '../Images';

export interface CardDatum {
  image: string;
  cardName: string;
}

// Names in exact array order: majorArcana[0-21], then wands[0-13], cups[0-13], swords[0-13], pentacles[0-13]
const CARD_NAMES: string[] = [
  // Major Arcana
  'The Fool',
  'The Magician',
  'The High Priestess',
  'The Emperor',
  'The Empress',
  'The Hierophant',
  'The Lovers',
  'The Chariot',
  'Strength',
  'The Hermit',
  'Wheel of Fortune',
  'Justice',
  'The Hanged Man',
  'Death',
  'Temperance',
  'The Devil',
  'The Tower',
  'The Star',
  'The Moon',
  'The Sun',
  'Judgement',
  'The World',
  // Wands
  'Ace of Wands', 'Two of Wands', 'Three of Wands', 'Four of Wands',
  'Five of Wands', 'Six of Wands', 'Seven of Wands', 'Eight of Wands',
  'Nine of Wands', 'Ten of Wands', 'Page of Wands', 'Knight of Wands',
  'Queen of Wands', 'King of Wands',
  // Cups
  'Ace of Cups', 'Two of Cups', 'Three of Cups', 'Four of Cups',
  'Five of Cups', 'Six of Cups', 'Seven of Cups', 'Eight of Cups',
  'Nine of Cups', 'Ten of Cups', 'Page of Cups', 'Knight of Cups',
  'Queen of Cups', 'King of Cups',
  // Swords
  'Ace of Swords', 'Two of Swords', 'Three of Swords', 'Four of Swords',
  'Five of Swords', 'Six of Swords', 'Seven of Swords', 'Eight of Swords',
  'Nine of Swords', 'Ten of Swords', 'Page of Swords', 'Knight of Swords',
  'Queen of Swords', 'King of Swords',
  // Pentacles
  'Ace of Pentacles', 'Two of Pentacles', 'Three of Pentacles', 'Four of Pentacles',
  'Five of Pentacles', 'Six of Pentacles', 'Seven of Pentacles', 'Eight of Pentacles',
  'Nine of Pentacles', 'Ten of Pentacles', 'Page of Pentacles', 'Knight of Pentacles',
  'Queen of Pentacles', 'King of Pentacles',
];

export const deckData: CardDatum[] = deckImages.map((image: string, index: number) => ({
  image,
  cardName: CARD_NAMES[index] ?? `Card ${index}`,
}));
